import React from 'react';

import { useHistory } from 'react-router-dom';

import Icon from 'components/common/Icons/base/Icon/Icon';

import { Button } from 'components/DesignSystem/Button';

export const ClearButton = () => {
    const history = useHistory();
    const handleClear = () => {
        history.replace({
            search: '',
        });
    };

    return (
        <Button
            startIcon={<Icon size={'20px'} name={'filter-clear'} color={'var(--button-secondary-fg'} />}
            variant={'secondary'}
            onClick={handleClear}
            data-testid={'clear-filter'}
        >
            Clear Filter
        </Button>
    );
};
